import { useQuery } from 'react-query'
import { getQueryDefaults } from '../../helpers/api'
import { useAuthSettings } from '../authorization'

import { getChromeBotClientEvents } from './requests'

export const useClientEventsQuery = () => {
  const authSettings = useAuthSettings()

  return useQuery(
    ['clientEvents'],
    () => getChromeBotClientEvents(authSettings),
    {
      ...getQueryDefaults(),
      staleTime: Infinity,
      enabled: Boolean(authSettings),
    }
  )
}
